import { useApi } from '@/composables/use-api'
import {
  IListAgentCategoryRequestQuery,
  IListAgentCategoryResponse,
  IListAgentRequestQuery,
  IListAgentResponse,
} from './types'

export const TaskLibraryApi = {
  getCategories(param?: Partial<IListAgentCategoryRequestQuery>) {
    const url = `/agents/categories`
    return useApi().get<IListAgentCategoryResponse>(url, { params: param })
  },

  getAgents(param?: Partial<IListAgentRequestQuery>) {
    const url = `/agents`
    return useApi().get<IListAgentResponse>(url, { params: param })
  },
}
